import { textStyle } from '@/components/ui/Typography/Body/Text/style';
import { tv } from '@/utils/libs/tailwind-variants';
/**
 * HotlineClientMypageList のスタイル
 */
export const hotlineClientMypageListStyle = tv({
    slots: {
        base: ['flex flex-col gap-y-16'],
        noDataBase: [
            textStyle({ color: 'base', size: 'sm' }),
            'pt-8 pb-24',
            'border-t-0 border-x-0 border-b border-solid border-gray-300',
        ],
    },
});
